import { apiClient } from '@/services/ApiClient.js'

export class DocumentService {
  getDocuments(query) {
    return apiClient
      .get('documents', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getDocument(document) {
    return apiClient
      .get('documents/' + document)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  upload(form) {
    let formData = new FormData()
    formData.append('notes', form.notes)
    let body = JSON.stringify({
      document_type: form.document_type
    })
    formData.append('json_body', body)

    return apiClient
      .postForm('documents', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  markCancelledDocumentsAsShipped(documents) {
    return apiClient
      .post('documents/mark-cancelled-documents-as-shipped', {
        documents: documents
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
